// import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Camada } from './camada.types';

export type FieldTypesNumber = '1' | '2' | '3' | '4' | '5' | '6';
export interface Formulario {
  id: number;
  projetoCamada?: Camada;
  fields?: FormlyFieldConfig[];
  nome?: string;
  ativo?: boolean;
  podeExcluir?: boolean;
  projetosCamadasFormulariosCampos: FieldTypeBack[];
  qtdObrigatorios?: number;
  qtdOpcionais?: number;
  totalDeCampos?: number;
}

export enum FieldTypeFront {
  TEXT = '1',
  INT = '2',
  NUM = '3',
  M_SELECT = '4',
  SELECT = '5',
  BOOLEAN = '6',
}

export enum FieldTypeFrontInt {
  TEXT = 1,
  INT = 2,
  NUM = 3,
  M_SELECT = 4,
  SELECT = 5,
  BOOLEAN = 6,
}

export interface FieldTypeForm {
  fieldName: string;
  fieldRequired: boolean;
  fieldType: FieldTypesNumber;
  fieldActive?: boolean;
  options?: Option[];
  id?: number;
}

export interface Option {
  optionName: string;
  optionActive?: boolean;
  id: number;
}

export interface FieldTypeBack {
  nome: string;
  obrigatorio: boolean;
  tipo: FieldTypesNumber;
  tipoCampo?: FieldTypesNumber;
  ativo?: boolean;
  fator?: string;
  representacao?: string;
  camposSelect?: CampoSelect[];
  publicoOuv?: boolean;
  id: number;
}

export interface CampoSelect {
  id: number;
  nome?: string;
  ordem?: number;
  fator?: number;
  ativo?: boolean;
}
